export class EstatisticaSintetica {
  name: string;
  value: number;
  extra: ExtraModel;
}

export class ExtraModel {
  id: number;
  tipo: string;
  descricao: string;
}